import { palette } from './palette';

// This functionality is left over from MUI template
// we are not using rem units in our project at this time.
// Currently going to keep fontSize in fixed units
// keeping in case we want to switch to rem units in the future.

//function pxToRem(value: number) {
//  return `${value / 16}rem`;
//}

// ----------------------------------------------------------------------

const FONT_PRIMARY = 'Roboto, sans-serif'; // Google Font
// const FONT_SECONDARY = 'CircularStd, sans-serif'; // Local Font

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontFamily: FONT_PRIMARY,
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: 1.5,
    color: palette().common.black,
  },
  h2: {
    fontFamily: FONT_PRIMARY,
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 1.5,
    color: palette().common.black,
  },
  h3: {
    fontFamily: FONT_PRIMARY,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 1.5,
    color: palette().common.black,
  },
  h4: {
    fontFamily: FONT_PRIMARY,
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: 1.5,
    color: palette().common.midGray,
  },
  //TODO: remove after refs are updates
  h5: {
    fontSize: '16px',
    color: palette().common.black,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  //TODO: remove after refs are updates
  h6: {
    fontSize: '16px',
    lineHeight: 1,
    color: palette().common.black,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  body1: {
    fontFamily: FONT_PRIMARY,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 1.5,
    color: palette().common.black,
  },
  //TODO: remove after refs are updates
  body2: {
    fontSize: '16px',
    color: palette().common.black,
  },
  subtitle1: {
    fontFamily: FONT_PRIMARY,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  //TODO: remove after refs are updates
  subtitle2: {
    fontWeight: 500,
    lineHeight: 22 / 14,
    fontSize: '14px',
    color: palette().common.black,
  },
  caption: {
    fontFamily: FONT_PRIMARY,
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  //TODO: remove after refs are updates
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: '16px',
    textTransform: 'uppercase',
    color: palette().common.black,
  },
  button: {
    fontFamily: FONT_PRIMARY,
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: 1.5,
    textTransform: 'none' as const,
  },
} as const;

export { typography };
